import { VARIABLE_ACCOUNT_ACTION_TOOLTIP } from "@common/constants/domains/accounting/chartOfAccountsTemplateAccount";
import { SYSTEM_ROLE_BLOCK_REASON } from "@components/accounting/chartOfAccounts/accountActionEligibility";
import { GetRowCapabilities } from "../editorCapabilities";
import { VARIABLE_INFO_TOOLTIP, VARIABLE_LABEL } from "../variableCopy";
import {
    NULL_TEMPLATE_IDENTITY,
    TemplateAccountIdentity,
} from "./templateDraftMapping";

interface MakeTemplateRowCapabilitiesParams {
    identityMap: Map<string, TemplateAccountIdentity>;
}

// Templates derive every per-row capability from the off-tree identity
// (variableKind) and the draft's role, using the same tooltip strings the row
// menu shows today. Variable placeholders are locked; every other row is editable.

export const makeTemplateRowCapabilities =
    ({ identityMap }: MakeTemplateRowCapabilitiesParams): GetRowCapabilities =>
    (account) => {
        const identity = identityMap.get(account.id) ?? NULL_TEMPLATE_IDENTITY;
        const isVariable = identity.variableKind != null;
        const role = account.role ?? null;
        const hasRole = role !== null;

        const roleBlockReason = hasRole ? SYSTEM_ROLE_BLOCK_REASON : null;
        const lockedOrRoleBlockReason = isVariable
            ? VARIABLE_ACCOUNT_ACTION_TOOLTIP
            : roleBlockReason;

        return {
            placeholder: isVariable
                ? { label: VARIABLE_LABEL, tooltip: VARIABLE_INFO_TOOLTIP }
                : null,
            codeEditBlockReason: isVariable
                ? VARIABLE_ACCOUNT_ACTION_TOOLTIP
                : null,
            renameBlockReason: isVariable
                ? VARIABLE_ACCOUNT_ACTION_TOOLTIP
                : null,
            typeChangeBlockReason: lockedOrRoleBlockReason,
            archiveBlockReason:
                account.isDisabled && !isVariable
                    ? null
                    : lockedOrRoleBlockReason,
            deleteBlockReason: lockedOrRoleBlockReason,
            mergeBlockReason: null,
            hasOpeningBalance: false,
            hasChartSeed: false,
            role,
        };
    };
